import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  /** 0-based index of the shown document. */
  index: number
  total: number
  onPrevious(): void
  onNext(): void
}

/** Prev / Next across the documents attached to one step. Renders nothing for a single file. */
const DocumentNavigatorComponent = ({ index, total, onPrevious, onNext }: Props) => {
  if (total <= 1) {
    return null
  }

  return (
    <div css={tw`flex flex-row items-center gap-2`}>
      <Button
        size="small"
        color="white"
        disabled={index === 0}
        leftIcon={<GSIcon iconName="gs_chevron_left_small" size={20} css={tw`text-shades-1000`} />}
        onClick={onPrevious}
        data-testid="document-review-previous-document"
      >
        Previous
      </Button>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {index + 1} / {total}
      </Typography>
      <Button
        size="small"
        color="white"
        disabled={index + 1 >= total}
        rightIcon={
          <GSIcon iconName="gs_chevron_right_small" size={20} css={tw`text-shades-1000`} />
        }
        onClick={onNext}
        data-testid="document-review-next-document"
      >
        Next
      </Button>
    </div>
  )
}

export const DocumentNavigator = memo(DocumentNavigatorComponent)
